/**
 * @title: 决策路由文件
 * @fileName: decision
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/20 18:38
 * @modified By：
 * @version:     1.0$
 * @description: TODO
 */
import PavementPlanningManagement from '@/views/decision/PavementPlanningManagement'
import Segmentation from '@/views/decision/PavementMaintenancePlanningCustomization/Segmentation'
import PreventiveMaintenance from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenance'
import BreakingRate from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/BreakingRate'
import MediumMaintenance from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/MediumMaintenance'
import OverhaulMaintenance from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/OverhaulMaintenance'
import DailyMaintenance from '@/views/decision/PavementMaintenancePlanningCustomization/DailyMaintenance'
import ConservationProgram from '@/views/decision/PavementMaintenancePlanningScheme/ConservationProgram'
import IndicatorsDuringThePlanningPeriod from '@/views/decision/PavementMaintenancePlanningScheme/IndicatorsDuringThePlanningPeriod'

import cxCementmeasures from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/cxCementmeasures'
import cxPitchmeasures from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/cxPitchmeasures'
import cxSandmeasures from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/cxSandmeasures'
import pmmeasurefs from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/pmmeasurefs'
import pmifws from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/pmifws'
import attributescores from '@/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/attributescores'

import pmdrepairs from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/MediumMaintenanceDic/pmdrepairs'//中修材料选择表
import predictionrules from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/MediumMaintenanceDic/predictionrules'//养护类型预测规律表
import repairthicknesses from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/MediumMaintenanceDic/repairthicknesses'//中修厚度推荐表
import overhaulmaterials from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/OverhaulMaintenanceDic/overhaulmaterials'//大修养护材料选择表
import overhaultypes from '@/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/OverhaulMaintenanceDic/overhaultypes'//大修类型判断表

import pmdInfluenceFactora from '@/views/macroDecisionMaking/pmdInfluenceFactora'//地区决策影响因素分类表
import pmdInfluenceFactorb from '@/views/macroDecisionMaking/pmdInfluenceFactorb'//宏观决策影响因素分类表
import pmdInfluenceFactorc from '@/views/macroDecisionMaking/pmdInfluenceFactorc'//宏观决策影响因素分值表
export default [{
    path: 'PavementPlanningManagement',
    name: 'PavementPlanningManagement',
    meta: {
        title: '路面规划管理',
        auth: true
    },
    component: PavementPlanningManagement
},{
    path: 'SegmentationA',
    name: 'Segmentation',
    meta: {
        title: '路段划分',
        auth: true
    },
    component: Segmentation
},{
    path: 'PreventiveMaintenance',
    name: 'PreventiveMaintenance',
    meta: {
        title: '预防性养护',
        auth: true
    },
    component: PreventiveMaintenance
},{
    path: 'BreakingRate',
    name: 'BreakingRate',
    meta: {
        title: '断板率',
        auth: true
    },
    component: BreakingRate
},{
    path: 'MediumMaintenance',
    name: 'MediumMaintenance',
    meta: {
        title: '功能性修复',
        auth: true
    },
    component: MediumMaintenance
},{
    path: 'OverhaulMaintenance',
    name: 'OverhaulMaintenance',
    meta: {
        title: '结构性修复',
        auth: true
    },
    component: OverhaulMaintenance
},{
    path: 'DailyMaintenanceCy',
    name: 'DailyMaintenance',
    meta: {
        title: '日常养护',
        auth: true
    },
    component: DailyMaintenance
},{
    path: 'ConservationProgram',
    name: 'ConservationProgram',
    meta: {
        title: '养护方案',
        auth: true
    },
    component: ConservationProgram
},{
    path: 'IndicatorsDuringThePlanningPeriod',
    name: 'IndicatorsDuringThePlanningPeriod',
    meta: {
        title: '规划期指标统计',
        auth: true
    },
    component: IndicatorsDuringThePlanningPeriod
},{
    path: 'cxCementmeasuresZ',
    name: 'cxCementmeasuresZ',
    meta: {
        title: '水泥路面预防性养护初选库',
        auth: true
    },
    component: cxCementmeasures
},{
    path: 'cxPitchmeasuresZ',
    name: 'cxPitchmeasuresZ',
    meta: {
        title: '沥青路面预防性养护初选库',
        auth: true
    },
    component: cxPitchmeasures
},{
    path: 'cxSandmeasuresZ',
    name: 'cxSandmeasuresZ',
    meta: {
        title: '砂石路面预防性养护初选库',
        auth: true
    },
    component: cxSandmeasures
},{
    path: 'pmmeasurefsZ',
    name: 'pmmeasurefsZ',
    meta: {
        title: '预防性养护措施的使用寿命与单位费用范围',
        auth: true
    },
    component: pmmeasurefs
},{
    path: 'pmifwsZ',
    name: 'pmifwsZ',
    meta: {
        title: '不同等级公路的影响因素权重系数Wi',
        auth: true
    },
    component: pmifws
},{
    path: 'attributescoresZ',
    name: 'attributescoresZ',
    meta: {
        title: '各常用预防性养护措施的属性分值范围Cij',
        auth: true
    },
    component: attributescores
},{
    path: 'pmdrepairs',
    name: 'pmdrepairs',
    meta: {
        title: '沥青功能性修复材料推荐',
        auth: true
    },
    component: pmdrepairs
},{
    path: 'predictionrules',
    name: 'predictionrules',
    meta: {
        title: '养护类型预测规律表',
        auth: true
    },
    component: predictionrules
},{
    path: 'repairthicknesses',
    name: 'repairthicknesses',
    meta: {
        title: '功能性修复厚度推荐表',
        auth: true
    },
    component: repairthicknesses
},{
    path: 'overhaulmaterials',
    name: 'overhaulmaterials',
    meta: {
        title: '结构性修复材料选择表',
        auth: true
    },
    component: overhaulmaterials
},{
    path: 'overhaultypes',
    name: 'overhaultypes',
    meta: {
        title: '结构性修复类型判断表',
        auth: true
    },
    component: overhaultypes
},{
    path: 'pmdInfluenceFactora',
    name: 'pmdInfluenceFactora',
    meta: {
        title: '地区决策影响因素分类表',
        auth: true
    },
    component: pmdInfluenceFactora
},{
    path: 'pmdInfluenceFactorb',
    name: 'pmdInfluenceFactorb',
    meta: {
        title: '宏观决策影响因素分类表',
        auth: true
    },
    component: pmdInfluenceFactorb
},{
    path: 'pmdInfluenceFactorc',
    name: 'pmdInfluenceFactorc',
    meta: {
        title: '宏观决策影响因素分值表',
        auth: true
    },
    component: pmdInfluenceFactorc
}
]
